import Immutable from 'immutable';

// this shit probably works only on 'flat' forms
// i have no clue what purpose is for nested paths anyway
export function filterShowedError(form) {
    // chyby len pre polia, ktore boli touchnute
    // alebo vsetky ak je forcovana validacia (po submite)
    const validatorError = form.get('validatorError');
    let fields;

    if (form.get('forcedValidation')) {
        fields = validatorError.keySeq();
    } else {
        //forms js ma mapu touchnutych poli v sprostom formate - klucom je List v ktorom je nazov pola
        fields = form
            .get('touchedFields')
            .filter(Boolean)
            .keySeq()
            .map(key => key.get(0))
            .filter(Boolean);
    }
    return fields.reduce((acc, path) => {
        const errors = validatorError.get(path, {}).errors || Immutable.List();
        if (errors.size) {
            return acc.set(path, errors.join(', '));
        }
        return acc.remove(path);
    }, Immutable.Map());
}

export function onChangedErrors(form, oldForm, onChangedError) {
    const errors = filterShowedError(form);
    const oldErrors = filterShowedError(oldForm);
    errors.forEach((error, path) => {
        if (oldErrors.get(path) !== error) {
            onChangedError(path, error);
        }
    });
}
